<div class="flex flex-col gap-4">
  @if (errorMessage) {
    <div class="p-3 bg-red-50 text-red-700 rounded-lg text-sm">
      {{ errorMessage }}
    </div>
  }

  <div #paymentElement class="min-h-[200px]">
    @if (isLoading) {
      <div class="flex items-center justify-center h-[200px] text-surface-400 dark:text-surface-500">
        <i class="pi pi-spinner pi-spin text-2xl"></i>
      </div>
    }
  </div>

  <div class="flex justify-end gap-2 pt-2">
    <p-button
      label="Abbrechen"
      [outlined]="true"
      [rounded]="true"
      (onClick)="close()"/>
    <p-button
      label="Speichern"
      [rounded]="true"
      [loading]="isSubmitting"
      [disabled]="isLoading || !!errorMessage"
      (onClick)="submit()"/>
  </div>
</div>
